import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Loading from './pages/Loading';
import Login from './pages/Login';
import Home from './pages/Home';
import Notification from './pages/Notification';
import Chat from './pages/Chat';
import Person from './pages/Person';
import Mural from './pages/Mural';
import Settings from './pages/Settings';
import Termos from './pages/security/Termos';
import Privacidade from './pages/security/Privacidade';
import Redefinir from './pages/Redefinir';
import NotificationPermition from './pages/security/Notification';

// FUNÇÃO
import { lerAvisos } from './firebase/avisos';
import { lerEvento } from './firebase/evento';
import { lerComunicados } from './firebase/comunicados';
import { db, auth, authFormularios, ANO } from './firebase/logar';
import Swal from 'sweetalert';

const App = () => {

  const logado = localStorage.getItem('logado');
  const evento = localStorage.getItem('tema');
  const seriesLista = JSON.parse(localStorage.getItem('series'));
  const comunicadosLista = JSON.parse(localStorage.getItem('comunicados'));

  function tirarAcento(texto) {
    
    texto = texto.replace(/ç/g, 'c');
    texto = texto.replace(/ã/g, 'a').replace(/õ/g, 'o').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');  
    return texto;
  
  }

  if (logado && logado !== 'RESPONSAVEL') {
    if (typeof authFormularios !== 'undefined') {
        authFormularios.onAuthStateChanged( async function(user) {
        if (!user) {
          localStorage.clear();
          window.location.href = "/logar/";
        } else {
          const nome = await tirarAcento(user.displayName);
          if (nome !== logado) {
            localStorage.clear();
            window.location.href = "/logar/";
          }
        }
      });
    }
  } else if (logado && logado === 'RESPONSAVEL'){
    auth.onAuthStateChanged( async function(user) {
      if (!user) {
        localStorage.clear();
        window.location.href = "/logar/";
      } else {
        const nome = user.displayName;
        const responsavel = localStorage.getItem('responsavel');
        if (nome !== responsavel) {
          localStorage.clear();
          window.location.href = "/logar/";
        }
      }
    });
  }

  useEffect(() => {
    const carregarEventos = async () => {
      try {
        const eventoAtual = await lerEvento();
        localStorage.setItem('tema', eventoAtual);
      } catch (error) {
        console.error('Erro ao carregar eventos:', error);
      }
    };

    const carregarAvisos = async () => {
      try {
        const avisos = await lerAvisos();
        localStorage.setItem('avisos', JSON.stringify(avisos));
      } catch (error) {
        console.error('Erro ao carregar avisos:', error);
      }
    };

    carregarEventos();
    if (logado) {
      carregarAvisos();
    }
  }, []);

  
  const lerSeries = useCallback( async () => {
    const url = window.location.pathname; // Ou substitua por sua string de URL
    const parts = url.split('/');
    const lastPart = parts.pop();
    
    if (lastPart !== 'chat') {
      await db.collection(ANO)
      .doc('restrito')
      .collection('series')
      .onSnapshot((data) => {
        const seriesList = data.docs.map((val) => val.id);
        localStorage.setItem('series', JSON.stringify(seriesList));
      });
    }
  }, []);

  useEffect(() => {
    if (!seriesLista || seriesLista.length === 0) {
      lerSeries();
    }
  }, []);

  useEffect(() => {
    const carregarComunicados = async () => {
      try {
        const comunicadosList = await lerComunicados();
        
        if (comunicadosList.name === 'FirebaseError' && comunicadosList.message.includes('Missing or insufficient permissions.')) {
          if (logado && logado !== 'off') {
            localStorage.setItem('logado', 'off');
            window.location.href = "/logar/";
          }
        } else {
          localStorage.setItem('comunicados', JSON.stringify(comunicadosList));
          const storedComunicados = localStorage.getItem('comunicados');
        }
      } catch (error) {
        console.error('Erro ao carregar comunicados:', error);
      } finally {
        //console.log('comunicados carregado')
      }
    };

    carregarComunicados();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Loading />} />
        <Route path="/logar" element={<Login />} />
        <Route path="/redefinir" element={<Redefinir />} />
        <Route path="/security/termos" element={<Termos />} />
        <Route path="/security/privacidade" element={<Privacidade />} />
        <Route path="/security/notification" element={<NotificationPermition />} />
        <Route
          path="/app/*"
          element={
            <div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/inicio" element={<Home />} />
                <Route path="/notificacoes" element={<Notification />} />
                <Route path="/mensagens" element={<Chat />} />
                <Route path="/perfil" element={<Person />} />
                <Route path="/mural" element={<Mural />} />
                <Route path="/configuracoes" element={<Settings />} />
              </Routes>
              <Navbar />
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
